import { hotRankIds, getArticleById, categories } from '@/mocks/melons';

export default function HomeHero() {
  const hotFirst = getArticleById(hotRankIds[0].id);
  const quickItems = hotRankIds.slice(1, 4).map((h) => getArticleById(h.id)).filter(Boolean);

  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div
        className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full opacity-60"
        style={{ background: 'radial-gradient(closest-side, oklch(var(--primary-100)), transparent)' }}
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full opacity-50"
        style={{ background: 'radial-gradient(closest-side, oklch(var(--accent-100)), transparent)' }}
        aria-hidden="true"
      />

      <div className="container-page relative grid grid-cols-1 items-center gap-10 py-12 md:py-16 lg:grid-cols-2 lg:gap-14 lg:py-20">
        <div className="flex flex-col items-start">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-100 px-3.5 py-1.5 text-xs font-semibold text-accent-900">
            <i className="ri-megaphone-line" aria-hidden="true" />
            瓜田盘点进行中 · 今日已更新 {categories.length} 大栏目
          </span>
          <h1 className="mt-5 text-4xl font-black leading-[1.15] text-foreground-950 md:text-5xl lg:text-[58px] lg:leading-[1.12]">
            一条读完
            <br />
            <span className="relative inline-block text-primary-600">
              必吃瓜
              <span
                className="absolute -bottom-1 left-0 h-2 w-full rounded-full opacity-30"
                style={{ background: 'oklch(var(--primary-300))' }}
                aria-hidden="true"
              />
            </span>
            的瓜田盘点
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            快手吃瓜瓜料大全，以瓜田盘点为主线，把散落在动态里的精品瓜整理成瓜料合集与精华总结。不用挨个刷屏，来这里一次补齐今天的热闹。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-7 py-3.5 text-[15px] font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-fire-line text-lg" aria-hidden="true" />
              查看今日热榜
            </a>
            <a
              href="#featured"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 py-3.5 text-[15px] font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              浏览瓜田精选
              <i className="ri-arrow-right-line text-lg" aria-hidden="true" />
            </a>
          </div>

          <dl className="mt-10 grid w-full grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {[
              { k: '专题盘点', v: '40+', d: '持续沉淀中' },
              { k: '瓜料分类', v: '6', d: '热门栏目' },
              { k: '单周阅读', v: '800w+', d: '吃瓜群众' },
            ].map((s) => (
              <div key={s.k} className="flex flex-col">
                <dt className="text-xs text-foreground-600">{s.k}</dt>
                <dd className="mt-1 flex items-baseline gap-1.5">
                  <span className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{s.v}</span>
                  <span className="text-xs text-foreground-500">{s.d}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20scene%20of%20gossip%20community%20corner%20with%20large%20watermelon%20slices%2C%20speech%20bubbles%2C%20popcorn%2C%20cellphone%20and%20megaphone%2C%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20friendly%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=hero-gua-2026&orientation=landscape"
              alt="快手吃瓜瓜料大全 - 瓜田盘点主题插画"
              className="h-64 w-full object-cover object-top md:h-[420px]"
            />
            <div
              className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"
              aria-hidden="true"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1.5 text-xs font-bold text-primary-700 backdrop-blur">
              <i className="ri-flashlight-line" aria-hidden="true" />
              头条 · {hotFirst?.tagLabel ?? '热'}
            </span>
          </div>

          {hotFirst && (
            <div className="absolute -left-3 top-6 hidden w-[46%] rounded-xl border border-background-200 bg-background-50 p-4 shadow-[0_10px_30px_-12px_oklch(var(--foreground-950)/0.25)] md:block lg:-left-6">
              <p className="eyebrow text-[11px] font-semibold text-primary-600">今日头条</p>
              <a href={`/post/${hotFirst.id}`} className="mt-1.5 block font-heading text-[15px] font-bold leading-snug text-foreground-950 hover:text-primary-700">
                {hotFirst.title}
              </a>
              <p className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-eye-line" aria-hidden="true" />
                {hotFirst.viewsText} 围观
              </p>
            </div>
          )}

          <div className="mt-4 rounded-xl border border-background-200 bg-background-50 p-3 shadow-[0_10px_30px_-14px_oklch(var(--foreground-950)/0.22)] md:mt-0 md:absolute md:bottom-6 md:right-4 md:w-[46%] lg:-right-4">
            <p className="flex items-center gap-1.5 px-2 text-xs font-semibold text-foreground-700">
              <i className="ri-fire-fill text-accent-500" aria-hidden="true" />
              正在热聊 · 3 条
            </p>
            <ul className="mt-2">
              {quickItems.map((a) =>
                a ? (
                  <li key={a.id}>
                    <a href={`/post/${a.id}`} className="flex items-center gap-2 px-2 py-1.5 text-sm leading-snug text-foreground-800 transition-colors hover:text-primary-700">
                      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-100 text-[11px] font-bold text-primary-700">
                        {hotRankIds.find((h) => h.id === a.id)?.rank}
                      </span>
                      <span className="min-w-0 flex-1 line-clamp-1">{a.title}</span>
                    </a>
                  </li>
                ) : null,
              )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}